import { TIME_SLOT_TYPE } from "constants/order";
import { ORDER_TYPE } from "constants/order";
import { useForwardOrderMultiple, useTimeSlots } from "hooks";
import { checkErrorForHandleOrdersCoordinate } from "pages/Orders/utils";
import React, { useEffect, useMemo, useState } from "react";
import { useToasts } from "react-toast-notifications";
import OrderCoordinationForm from "pages/Orders/OrderDetail/OrderCoordination/OrderCoordinationForm/OrderCoordinationForm";
import { Modal } from "reactstrap";

const initRunnerByRuleParams = {
  action_date: "",
  time_slot: 0,
  province_code: "",
  district_code: "",
  ward_code: "",
};

const useCoordinateOrder = ({ onSuccesCoordinate }) => {
  const { addToast } = useToasts();
  const [isOpenModalCoordinate, setIsOpenModalCoordinate] = useState(false);
  const [orderId, setOrderId] = useState(undefined);
  const [defaultData, setDefaultData] = useState(null);
  const [isAddressLevel2, setIsAddressLevel2] = useState(false);

  const [hubId, setHubId] = useState(null);
  const [timeSlotsParams, setTimeSlotsParams] = useState({
    params: {
      "filter[type][in]": [TIME_SLOT_TYPE.COORDINATE, TIME_SLOT_TYPE.RUNNER],
      "filter[hub_id]": undefined,
    },
    run: false,
    enabled: false,
    key: "time-slot-orders",
  });
  const [runnerByRuleParams, setRunnerByRuleParams] = useState(
    initRunnerByRuleParams
  );

  const { mutate: onForwardOrder } =
    useForwardOrderMultiple(onSuccesCoordinate);

  const { data: timeSlots, refetch: refetchTimeSlots } =
    useTimeSlots(timeSlotsParams);

  useEffect(() => {
    if (timeSlotsParams && timeSlotsParams?.run) {
      refetchTimeSlots();
    }
  }, [timeSlotsParams]);

  const handleCoordinate = row => {
    setOrderId(row?.id);
    let { messError, hub_id } = checkErrorForHandleOrdersCoordinate({
      selectedRows: [row],
    });

    if (messError) {
      addToast(messError, {
        appearance: "warning",
        autoDismiss: true,
      });
    } else {
      const isReceive = row?.type === ORDER_TYPE.RECEIVE.value;
      const prefix = isReceive ? "sender" : "reciever";

      const isNewAddress =
        row?.is_new_address !== undefined
          ? row.is_new_address
          : row?.[`${prefix}_ward_code`] === null
          ? "N"
          : "O";

      const addressLevel2 = isNewAddress === "N";
      setIsAddressLevel2(addressLevel2);

      const fullAddress = row?.[`${prefix}_address`] || "";
      const provinceCode = row?.[`${prefix}_province_code`] || null;
      const districtCode = row?.[`${prefix}_district_code`] || null;
      const wardCode = row?.[`${prefix}_ward_code`] || null;
      const contactName = row?.[`${prefix}_contact_name`] || "";
      const contactPhone = row?.[`${prefix}_contact_phone`] || "";

      let mappedWardCode = null;
      let mappedDistrictCode = null;

      if (addressLevel2) {
        mappedWardCode = null;
        mappedDistrictCode = districtCode;
      } else {
        mappedWardCode = wardCode;
        mappedDistrictCode = districtCode;
      }
      // default data

      const coordinationDefaultData = {
        timeslot_id: row?.timeSlot?.id,
        runner_id: row?.orderDelivery?.runner_id,
        full_address: fullAddress,
        ward_code: mappedWardCode,
        district_code: mappedDistrictCode,
        province_code: provinceCode,
        contact_name: contactName,
        contact_phone: contactPhone,
        note: `${row?.mainNote || row?.note || ""}`,
        is_new_address: isNewAddress,
      };

      setDefaultData(coordinationDefaultData);
      setHubId(hub_id);
      setTimeSlotsParams(prev => {
        return {
          ...prev,
          params: {
            ...prev.params,
            "filter[hub_id]": hub_id,
          },
          run: true,
        };
      });
      toggleModalCoordinate();
    }
  };
  const toggleModalCoordinate = () => {
    setIsOpenModalCoordinate(prev => !prev);
    if (isOpenModalCoordinate) {
      setDefaultData(null);
      setIsAddressLevel2(false);
    }
  };

  const onTimeSlotChange = timeslot_id => {
    const params = { ...runnerByRuleParams };
    params.time_slot = timeslot_id;
    setRunnerByRuleParams(params);
  };

  const onActionDateChange = action_date => {
    const params = { ...runnerByRuleParams };
    params.action_date = action_date;
    setRunnerByRuleParams(params);
  };

  const handleForwardOrder = data => {
    const forwardOrderParams = { ...data };
    forwardOrderParams.ids = [orderId];
    onForwardOrder(forwardOrderParams);
  };

  const OrderCoordinateModal = useMemo(() => {
    return (
      <Modal
        isOpen={isOpenModalCoordinate}
        centered
        toggle={toggleModalCoordinate}
        scrollable
        size="xl"
      >
        {isOpenModalCoordinate && (
          <OrderCoordinationForm
            defaultData={defaultData}
            timeSlots={timeSlots?.items}
            hubId={hubId}
            isAddressLevel2={isAddressLevel2}
            handleCancel={toggleModalCoordinate}
            onTimeSlotChange={onTimeSlotChange}
            onActionDateChange={onActionDateChange}
            onForwardOrder={handleForwardOrder}
          />
        )}
      </Modal>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isOpenModalCoordinate,
    hubId,
    timeSlots,
    defaultData,
    isAddressLevel2,
    orderId,
  ]);

  return {
    handleCoordinate,
    OrderCoordinateModal,
  };
};

export default useCoordinateOrder;
